import { UserManager } from "oidc-client-ts";
import { DevAuthManager } from "./dev-auth-manager";

const authority = process.env.REACT_APP_KEYCLOAK_AUTHORITY;
const clientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;
const wovoHomePageUrl = `${window.location.origin}/app/dashboard`;

// Check if Keycloak configuration is available
const hasKeycloakConfig = !!(authority && clientId);

export const devAuthManager = new DevAuthManager();

// Disable session monitoring for local development to avoid cross-origin iframe issues
const isLocalDev =
  typeof window !== "undefined" && window.location.hostname === "localhost";

// Create the appropriate auth manager based on environment
export const userManager = hasKeycloakConfig
  ? new UserManager({
      authority,
      client_id: clientId,
      redirect_uri: wovoHomePageUrl,
      post_logout_redirect_uri: wovoHomePageUrl,
      monitorSession: !isLocalDev, // disable for local dev to avoid cross-origin issues
      loadUserInfo: true,
    })
  : devAuthManager;

export const onSigninCallback = () => {
  // Remove only the OIDC auth params, preserve other query params (like ?id=...)
  const url = new URL(window.location.href);
  const authParams = ["code", "state", "session_state", "iss"];
  for (const param of authParams) {
    url.searchParams.delete(param);
  }

  const cleanUrl = url.pathname + url.search + url.hash;
  window.history.replaceState({}, document.title, cleanUrl);
};

// Export a flag to indicate which auth method is being used
export const isUsingKeycloak = hasKeycloakConfig;
